import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class DepartmentStore {
  departments = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      loading: observable,
      departments: observable,
      getUserDepartmentData: action,
      getDepartmentData: action,

      addDepartment: action,
    });
    this.rootStore = rootStore;
  }

  async getDepartmentData() {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("department/getDepartment");
    var allDepartment = [{ departmentId: "0", departmentName: "All" }];
    allDepartment = [...allDepartment, ...response?.data?.data];
    this.departments = allDepartment;
  }

  // async getDepartmentData(){
  //     var postData = {}
  //     const base64Input = {};
  //     var response = await postApi.getClient().post("index.php?c=salesperson&a=getDepartment", "postData="+base64Input);
  //     var departments = [...response?.data?.data];
  //     console.log(departments)

  //     var allDepartment = [{departmentId:"0",departmentName:"All"}]

  //     allDepartment = [...allDepartment,...response?.data?.data]
  //     console.log(allDepartment)
  //     this.departments = allDepartment;
  // }

  async getUserDepartmentData() {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("department/getDepartment");
    this.departments = response?.data?.data;
  }

  // async getUserDepartmentData() {
  //   var postData = {};
  //   const base64Input = {};
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=getDepartment",
  //       "postData=" + base64Input
  //     );
  //   var departments = [...response?.data?.data];
  //   console.log(departments);
  //   this.departments = response?.data?.data;
  // }

  async addDepartment(departmentDetails) {
    var postData = departmentDetails;
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("department/addDepartment", { postData });
    return response;
  }

  // async addDepartment(departmentDetails) {
  //   var postData = departmentDetails;
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=salesperson&a=addDepartment",
  //       "postData=" + base64Input
  //     );
  //   console.log(response, "adddept");
  //   return response;
  // }
}

export default DepartmentStore;
